import type { IconSvgObject } from './types';

const Blockchain01Icon: IconSvgObject = [
  ["path", { d: "M20 7.5L12 3L4 7.5M20 7.5L12 12M20 7.5V16.5L12 21L4 16.5V7.5M12 12L4 7.5M12 12V20.2354", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default Blockchain01Icon;
